import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useExperiences } from 'core/contexts/experienceV2';
import Layout from 'components/Layout';
import { CircularIndeterminate } from '@utriper/core-ui';
import { Grid2, Typography } from '@mui/material';
import { Section } from 'modules/Pricing/styles';
import ExperienceFilters from './components/ExperienceFilters';
import ExperienceCards from './components/ExperienceCards';
import FiltersForm from './components/FiltersForm';
import ExperienceNoData from './components/ExperienceNoData';
import ExperienceTable from './components/ExperienceTable';
import ExperienceStatus from './components/ExperienceStatus';

const ExperienceListPage = () => {
    const { t: translate } = useTranslation();
    const { getExperiences, expView, loading, hasFilters, experiences, allExperiencesCount, expPage, filters, nameFilterDebounce } = useExperiences();

    useEffect(() => {
        getExperiences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expPage, nameFilterDebounce, filters]);

    return (
        <Layout>
            <Section style={{ overflow: 'visible' }}>
                {/* Title */}
                <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px">
                    <Typography fontSize={20} fontWeight={900} sx={{ color: '#131313' }} noWrap>
                        {translate('experience_list.title')}
                    </Typography>
                    <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }}>
                        {translate('experience_list.subtitle')}
                    </Typography>
                </Grid2>

                {/* Filters */}
                <ExperienceFilters />
                <FiltersForm />

                {/* Statuses */}
                <ExperienceStatus />

                {/* Experiences */}
                {loading ? <CircularIndeterminate /> : experiences?.length > 0 && expView === 'gallery' ? <ExperienceCards /> : experiences?.length > 0 && expView === 'table' ? <ExperienceTable /> : allExperiencesCount <= 0 || hasFilters() ? <ExperienceNoData /> : ''}
            </Section>
        </Layout>
    );
};

export default ExperienceListPage;
